import clsx from 'clsx';
import { TrackedButton } from '@objectiv/tracker-react';

import * as styles from './MobileMenuToggle.module.css';

type MobileMenuToggleProps = {
  className?: string;
  isOpen?: boolean;
  onClick?: () => void;
};

export const MobileMenuToggle: React.FC<MobileMenuToggleProps> = ({ className, isOpen, onClick }) => (
  <TrackedButton
    objectiv={{ id: 'mobile-menu-toggle' }}
    className={clsx(styles.mobileMenuToggle, isOpen && styles.open, className)}
    onClick={onClick}
  >
    <span className={styles.line} />
    <span className={styles.line} />
    <span className={styles.line} />
  </TrackedButton>
);
